import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GetSiteListDto, LogistiqueSettings, SitesLexiClient } from '@lexi-clients/lexi';
import { DxDataGridComponent } from 'devextreme-angular';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-gestion-logistique',
    templateUrl: './gestion-logistique.component.html',
    styleUrls: ['./gestion-logistique.component.scss'],
    standalone: false
})
export class GestionLogistiqueComponent implements OnInit {
  @ViewChild(DxDataGridComponent) datagrid: DxDataGridComponent;
  @Input() colCount: number = 2;
  @Input() colSpan: number = 1;
  @Input() logistiqueSettings: LogistiqueSettings = {};
  @Input() formIsReadOnly: boolean = false;
  @Input() isFromSociete: boolean = false;
  @Input() resetCompteur: () => Promise<void>;
  sites: GetSiteListDto[] = [];

  constructor(private readonly sitesLexiClient: SitesLexiClient) { }

  async ngOnInit() {
    this.sites = await lastValueFrom(this.sitesLexiClient.getAll());
  }

  async onKeyDown(e) {
    if (!this.formIsReadOnly && e.event.key === "Insert") {
      this.datagrid.instance.addRow();
    }
  }
}
